/**
 * 中文业务注释补充：文件级
 * @file CropAgent 前端模块的 main，提供main相关的应用装配、常量定义或共享类型能力。
 * @description 由页面、组件、状态管理或服务适配层导入，并通过既有公开接口参与前端业务流程。
 * @author kzxz182
 * @since 2026-07-18
 * @remarks 技术栈：TypeScript。保持既有权限、工作空间和设备安全边界，异常状态必须由调用方显式处理。
 */
const PUBLIC_VIDEO_PATH = '/public/video'

/**
 * 固定二维码页面使用轻量入口；其他地址继续加载原业务应用和全部既有插件。
 */
async function bootstrapApplication (): Promise<void> {
  const normalizedPath = window.location.pathname.replace(/\/+$/, '') || '/'
  // 中文说明：诊断页只读取本机Gamepad，不启动登录、地图、直播、MQTT或控制初始化。
  const diagnosticPath = `${import.meta.env.BASE_URL}gamepad-diagnostic`.replace(/\/+$/, '')
  if (normalizedPath === diagnosticPath) {
    const { mountGamepadDiagnosticApp } = await import('./gamepad-diagnostic-entry')
    mountGamepadDiagnosticApp()
    return
  }
  if (normalizedPath === PUBLIC_VIDEO_PATH) {
    const { mountPublicVideoApp } = await import('./public-video-entry')
    mountPublicVideoApp()
    return
  }

  await import('./application-entry')
}

bootstrapApplication().catch(error => {
  // 启动异常只显示通用提示，禁止向公开页面输出内部模块或服务信息。
  console.error('前端页面启动失败', error)
  const mountElement = document.getElementById('demo-app')
  if (mountElement) mountElement.textContent = '页面加载失败，请刷新后重试。'
})
